import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import Box from '../Box';
import DragDrop from '../DragDrop';
import Icon from '../Icon';
import List from '../List';
import { SORTABLE_TYPE } from './constants';
export var SORTABLE_ITEM_DISPLAY_NAME = 'SortableItem';

var _ref2 = /*#__PURE__*/React.createElement(Icon, {
  name: "drag-handle",
  size: "sm",
  color: "foregroundTertiary"
});

function SortableItem(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      id = _ref.id,
      index = _ref.index,
      isDraggingOver = _ref.isDraggingOver,
      onRemoveRequest = _ref.onRemoveRequest,
      readOnly = _ref.readOnly,
      restProps = _objectWithoutPropertiesLoose(_ref, ["children", "disabled", "id", "index", "isDraggingOver", "onRemoveRequest", "readOnly"]);

  return /*#__PURE__*/React.createElement(DragDrop.Draggable, {
    type: SORTABLE_TYPE,
    draggableId: id,
    isDragDisabled: disabled || readOnly,
    index: index
  }, function (provided) {
    return /*#__PURE__*/React.createElement(List.Item, _extends({
      innerRef: provided.innerRef,
      onRemoveRequest: onRemoveRequest
    }, restProps, provided.draggableProps), !readOnly && /*#__PURE__*/React.createElement(Box, _extends({}, provided.dragHandleProps, {
      marginRight: 1
    }), _ref2), children);
  });
}

SortableItem.displayName = SORTABLE_ITEM_DISPLAY_NAME;
export default SortableItem;